// src/app/core/api/models.ts
// Generated from OpenAPI 3.1 specification
// DO NOT EDIT MANUALLY - Regenerate using OpenAPI spec
// Last updated: 2026-06-13
// ============================================
// ENUMS & TYPES
// ============================================

export type EntityStatus = 'AVAILABLE' | 'RESERVED' | 'SOLD';
export type DayOfWeek = 'MONDAY' | 'TUESDAY' | 'WEDNESDAY' | 'THURSDAY' | 'FRIDAY' | 'SATURDAY' | 'SUNDAY';
export type PlaceType = 'HEADQUARTER' | 'INVESTMENT' | 'SELLING_POINT';
export type GlobalRole = 'ADMIN' | 'DEV' | 'MULTITENANCY_USER' | 'REGULAR_USER';
export type AddonDomain = 'PARKING_TYPE' | 'PARKING' | 'ANCILLARY_TYPE' | 'ANCILLARY';
export type PropertyType = 'APARTMENT' | 'HOUSE';
// OPENAPI-GEN:BEGIN addressing-mode

// OPENAPI-GEN:END addressing-mode
export type LongId = number;

// ============================================
// SHARED MODELS
// ============================================

export interface PictureMediaItem {
  name?: string;
  src?: string;
  order?: number;
}

export interface OpeningHours {
  fromDay?: DayOfWeek;
  toDay?: DayOfWeek;
  fromHour?: string;
  toHour?: string;
}

export interface PageableObject {
  offset: number;
  sort: SortObject;
  pageSize: number;
  pageNumber: number;
  paged: boolean;
  unpaged: boolean;
}

export interface SortObject {
  empty: boolean;
  sorted: boolean;
  unsorted: boolean;
}

export interface PageResponse<T> {
  content: T[];
  pageNumber: number;
  pageSize: number;
  totalElements: number;
  totalPages: number;
  first: boolean;
  last: boolean;
}

// ============================================
// DEVELOPER MODELS
// ============================================

export interface CompanyBaseDto {
  id: number;
  companyName: string;
  nip: string;
  regon?: string | null;
  krs?: string | null;
  ceidg?: string | null;
  legalFormCode: string;
  countryCode?: string | null;
  voivodeshipCode: string;
  district: string;
  commune: string;
  postalCode: string;
  city: string;
  street: string;
  buildingNumber: string;
  apartmentNumber?: string | null;
}

export interface DeveloperCompanyDto extends CompanyBaseDto { }
export interface InvestmentCompanyDto extends CompanyBaseDto { }
export interface CompanyDto extends CompanyBaseDto { }

export interface CompanyDictionaryDto {
  code: string;
  label: string;
  sortOrder?: number;
  active: boolean;
}

export interface CompanyCreateRequest {
  companyName: string;
  nip: string;
  regon?: string | null;
  krs?: string | null;
  ceidg?: string | null;
  legalFormCode: string;
  countryCode?: string | null;
  voivodeshipCode: string;
  district: string;
  commune: string;
  postalCode: string;
  city: string;
  street: string;
  buildingNumber: string;
  apartmentNumber?: string | null;
}

/**
 * Backend uses JsonNullable semantics.
 * - field undefined: no change
 * - field null: clear value (optional fields)
 * - field value: update
 */
export interface CompanyUpdateRequest {
  companyName?: string | null;
  nip?: string | null;
  regon?: string | null;
  krs?: string | null;
  ceidg?: string | null;
  legalFormCode?: string | null;
  countryCode?: string | null;
  voivodeshipCode?: string | null;
  district?: string | null;
  commune?: string | null;
  postalCode?: string | null;
  city?: string | null;
  street?: string | null;
  buildingNumber?: string | null;
  apartmentNumber?: string | null;
}

export interface VersionedDto<T> {
  data: T;
  etag: string;
}

export interface DeveloperDto {
  id: number;
  name: string;
  shortName: string;
  logoUrl?: string | null;
  company?: DeveloperCompanyDto | null;
  headquarterId?: number;
  nip?: string;
  regon?: string;
  krs?: string;
  ceidg?: string;
  legalForm?: string;
  website?: string | null;
}

/**
 * Backend uses JsonNullable semantics.
 * - field undefined: no change
 * - field null: clear value
 * - field value: update
 */
export interface DeveloperUpdateRequest {
  name?: string | null;
  shortName?: string | null;
  website?: string | null;
}

export interface DeveloperCommand {
  name: string;
  headquarterId?: number;
  shortName: string;
  nip: string;
  regon: string;
  krs: string;
  ceidg: string;
  legalForm: string;
  website: string;
}

export interface CreateDeveloperCommand {
  developer: DeveloperCommand;
  headquarter: SellingPointRequest;
}

// ============================================
// PLACE MODELS (formerly Selling Points)
// ============================================

export interface PlaceDto {
  id: number;
  developerId: number;
  type?: PlaceType;
  title: string;
  postalCode: string;
  city: string;
  street: string;
  voivodeship?: string;
  district?: string;
  commune?: string;
  buildingNumber?: string;
  apartmentNumber?: string;
  latitude?: number;
  longitude?: number;
  openingHours?: OpeningHours[];
}

export interface SellingPointDto extends PlaceDto {
  investments?: InvestmentSelectOptionDto[];
}

export interface SellingPointRequest {
  title: string;
  postalCode: string;
  city: string;
  street: string;
  voivodeship: string;
  district: string;
  commune: string;
  buildingNumber: string;
  apartmentNumber?: string;
  latitude?: number;
  longitude?: number;
  openingHours?: OpeningHours[];
}

/** @deprecated Use SellingPointRequest */
export interface PlaceCommand extends SellingPointRequest { }

export interface LocationRequest {
  postalCode: string;
  city: string;
  street: string;
  voivodeship: string;
  district: string;
  commune: string;
  buildingNumber: string;
  apartmentNumber?: string;
  latitude?: number;
  longitude?: number;
}

// ============================================
// INVESTMENT MODELS
// ============================================

export interface GeoLocationDto {
  latitude?: number;
  longitude?: number;
}

export interface InvestmentAddressDto {
  postalCode: string;
  city: string;
  street: string;
  voivodeship?: string;
  district?: string;
  commune?: string;
  latitude?: number;
  longitude?: number;
}

export interface InvestmentCountsDto {
  apartmentCount: number;
  parkingCount: number;
  ancillaryCount: number;
  sellingPointCount: number;
}

export interface BuildingAddressDto {
  id: number;
  buildingNumber: string | null;
  entranceCode?: string | null;
}

// OPENAPI-GEN:BEGIN building-contracts
export interface BuildingAddressRequest {
  buildingNumber?: string;
  entranceCode?: string;
}

export interface BuildingRequest {
  buildingCode: string;
}

export interface CreateBuildingRequest extends BuildingRequest {
  addresses: BuildingAddressRequest[];
}

export interface ApartmentBuildingCreateRequest extends BuildingRequest {
  buildingAddress?: BuildingAddressRequest;
}

/** @deprecated Use ApartmentBuildingCreateRequest */
export interface BuildingToCreateRequest extends ApartmentBuildingCreateRequest { }
// OPENAPI-GEN:END building-contracts

export interface BuildingDto {
  id: number;
  buildingCode: string;
  addresses: BuildingAddressDto[];
}

export interface InvestmentDto {
  id: number;
  developerId: number;
  title: string;
  company?: InvestmentCompanyDto | null;
  logo?: string;
  description?: string;
  buildingPermitNumber?: string;
  saleStartDate?: string;
  internalNote?: string;
  archived: boolean;
  archivedDate?: string;
  prospectUrl?: string;
  // OPENAPI-GEN:BEGIN investment-dto-addressing

  // OPENAPI-GEN:END investment-dto-addressing
  address?: InvestmentAddressDto;
  location?: InvestmentAddressDto; // Added for backward compatibility with some components
  gov?: GovEditPolicyDto;
  buildings?: BuildingDto[];
}

export interface InvestmentWithCountsDto extends InvestmentDto {
  counts?: InvestmentCountsDto;
}

export interface InvestmentDetailsWithCountsDto extends InvestmentDto {
  counts?: InvestmentCountsDto;
  sellingPoints?: PlaceDto[];
}

export interface InvestmentSelectOptionDto {
  id: number;
  title: string;
}

export interface CreatedIdDto {
  id: number;
}

export interface InvestmentRequest {
  title: string;
  companyId?: number | null;
  description?: string;
  phase?: string;
  buildingPermitNumber?: string;
  internalNote?: string;
  // OPENAPI-GEN:BEGIN investment-request-addressing

  // OPENAPI-GEN:END investment-request-addressing
}

export interface InvestmentAddressRequest {
  postalCode: string;
  city: string;
  street: string;
  voivodeship: string;
  district: string;
  commune: string;
  latitude?: number;
  longitude?: number;
}

export interface CreateInvestmentRequest {
  title: string;
  companyId?: number | null;
  // OPENAPI-GEN:BEGIN create-investment-required-fields
  location: InvestmentAddressRequest;
  saleStartDate: string;
  internalNote?: string;
  buildings?: CreateBuildingRequest[];
  // OPENAPI-GEN:END create-investment-required-fields
}

// ============================================
// APARTMENT MODELS
// ============================================

export interface ApartmentBuildingAddressDto {
  id: number;
  buildingNumber: string | null;
  entranceCode?: string | null;
}

export interface ApartmentBuildingDto {
  id: number;
  code: string;
  address?: ApartmentBuildingAddressDto;
}

export interface ApartmentDto {
  id: number;
  name: string;
  propertyType?: string;
  building?: ApartmentBuildingDto | null;
  description?: string;
  floor?: number;
  size: number;
  rooms?: number;
  status: EntityStatus;
  internalNote?: string;
}

export interface ApartmentDetailsDto extends ApartmentDto {
  versions: ApartmentVersionDto[];
  apartmentAddonRules?: ApartmentAddonRuleDto[];
  currentVersion?: ApartmentVersionDto;
}

export interface ApartmentListBuildingAddressView {
  id?: number | null;
  buildingNumber?: string | null;
  entranceCode?: string | null;
}

export interface ApartmentListBuildingView {
  id?: number | null;
  code?: string | null;
  address?: ApartmentListBuildingAddressView | null;
}

export interface ApartmentListItemView {
  apartmentId: number;
  developerId: number;
  investmentId: number;
  name: string;
  propertyType?: PropertyType;
  building?: ApartmentListBuildingView | null;
  size: number;
  floor?: number;
  height?: number;
  rooms?: number;
  status: EntityStatus;
  currentPrice?: number;
  currentPricePerM?: number;
  currentPriceValidFrom?: string;
  nextPrice?: number;
  nextPricePerM?: number;
  nextPriceValidFrom?: string;
}

export interface ApartmentVersionDto {
  id: number;
  pricePerM: number;
  price: number;
  validFrom: string;
}

/** @deprecated Use PatchApartmentRequest. Backend update endpoint uses PATCH tri-state semantics. */
export type UpdateApartmentRequest = PatchApartmentRequest;

// OPENAPI-GEN:BEGIN patch-apartment-request
export interface PatchApartmentRequest {
  name?: string | null;
  buildingId?: number | null;
  buildingAddressId?: number | null;
  propertyType?: PropertyType | null;
  description?: string | null;
  internalNote?: string | null;
  floor?: number | null;
  size?: number | null;
  height?: number | null;
  rooms?: number | null;
  status?: EntityStatus | null;
}
// OPENAPI-GEN:END patch-apartment-request

export interface ApartmentVersionRequest {
  pricePerM: number;
  price: number;
  validFrom: string;
}

/** @deprecated Use ApartmentVersionRequest */
export interface CreateApartmentVersionCommand extends ApartmentVersionRequest { }

export interface UpdateApartmentVersionRequest {
  pricePerM: number;
  price: number;
  validFrom: string;
}

export interface PageApartmentListItemDto extends PageResponse<ApartmentListItemView> { }

// ============================================
// PARKING MODELS
// ============================================

export interface ParkingDto {
  id: number;
  parkingType: ParkingTypeDto;
  number: string;
  size?: number;
  floor?: number;
  status: EntityStatus;
  versions: ParkingVersionDto[];
  currentVersion?: ParkingVersionDto;
}

export interface ParkingDetailsDto {
  id: number;
  parkingType: ParkingTypeDto;
  number: string;
  size?: number;
  floor?: number;
  status: EntityStatus;
  versions: ParkingVersionDto[];
  currentVersion?: ParkingVersionDto;
}

export interface ParkingListItemView {
  parkingId: number;
  type: ParkingTypeView;
  developerId: number;
  investmentId: number;
  number: string;
  size?: number;
  floor?: number;
  status: string;
  currentPrice?: number;
  currentPriceValidFrom?: string;
  nextPrice?: number;
  nextPriceValidFrom?: string;
}

export interface ParkingTypeView {
  id: number;
  name: string;
}

export interface ParkingVersionDto {
  id: number;
  price: number;
  validFrom: string;
}

export interface ParkingRequest {
  parkingTypeId: number;
  number: string;
  size?: number;
  floor?: number;
  status: EntityStatus;
}

export interface CreateParkingRequest {
  parkingTypeId: number;
  number: string;
  size?: number;
  floor?: number;
  status: EntityStatus;
  version?: ParkingVersionRequest;
}

export interface ParkingVersionRequest {
  price: number;
  validFrom: string;
}

// ============================================
// PARKING TYPE MODELS
// ============================================

export interface ParkingTypeDto {
  id: number;
  name: string;
}

export interface ParkingTypeRequest {
  name: string;
}

// ============================================
// ANCILLARY SPACE MODELS
// ============================================

export interface AncillaryDetailsDto {
  id: number;
  ancillaryType: AncillaryTypeDto;
  number: string;
  size?: number;
  floor?: number;
  status: EntityStatus;
  versions: AncillaryVersionDto[];
  currentVersion?: AncillaryVersionDto;
}

export interface AncillaryListItemView {
  ancillaryId: number;
  ancillaryTypeId: number;
  developerId: number;
  investmentId: number;
  name: string;
  number: string;
  size?: number;
  floor?: number;
  status: string;
  currentPrice?: number;
  currentPriceValidFrom?: string;
  nextPrice?: number;
  nextPriceValidFrom?: string;
}

export interface AncillaryVersionDto {
  id: number;
  price: number;
  validFrom: string;
}

export interface AncillaryRequest {
  ancillaryTypeId: number;
  number: string;
  size?: number;
  floor?: number;
  status: EntityStatus;
}

export interface CreateAncillaryRequest {
  ancillaryTypeId: number;
  number: string;
  size?: number;
  floor?: number;
  status: EntityStatus;
  version?: AncillaryVersionRequest;
}

export interface AncillaryVersionRequest {
  price: number;
  validFrom: string;
}

// ============================================
// ANCILLARY TYPE MODELS
// ============================================

export interface AncillaryTypeDto {
  id: number;
  name: string;
}

export interface AncillaryType {
  id: number;
  developerId: number;
  investmentId: number;
  name: string;
}

export interface AncillaryTypeRequest {
  name: string;
}

// ============================================
// ADDON RULES MODELS
// ============================================

export interface ItemRefRequest {
  id?: number;
  domain: AddonDomain;
}

export interface TypeRefRequest {
  id?: number;
  domain: AddonDomain;
}

export interface ItemRef {
  id?: number;
  label?: string;
  domain: AddonDomain;
}

export interface TypeRef {
  id?: number;
  label?: string;
  domain: AddonDomain;
}

export interface ConditionRequest {
  min_qty?: number;
  types?: TypeRefRequest[];
  items?: ItemRefRequest[];
  exactlyOneBasket?: boolean;
}

export interface Condition {
  min_qty?: number;
  types?: TypeRef[];
  items?: ItemRef[];
}

export interface VariantRequest {
  all_of: ConditionRequest[];
}

export interface Variant {
  all_of?: Condition[];
}

export interface AddonRuleRequest {
  any_of: VariantRequest[];
}

export interface AddonRule {
  any_of?: Variant[];
}

export interface ApartmentAddonRuleRequest {
  mandatory: boolean;
  validFrom: string;
  addonRule: AddonRuleRequest;
}

export interface ApartmentAddonRuleDto {
  id: number;
  mandatory: boolean;
  validFrom: string;
  ruleText?: string;
  addonRule?: AddonRule;
}

// ============================================
// USER MODELS
// ============================================

export interface UserEntity {
  id: number;
  username: string;
  email: string;
  password: string;
  name: string;
  surname: string;
  externalProvider?: string;
  externalId?: string;
  createdDate: string;
  modifiedDate: string;
  modifiedBy?: string;
}

export interface UserDto {
  id: number;
  username: string;
  email: string;
  name: string;
  surname: string;
  globalRoles: GlobalRole[];
  createdDate: string;
  modifiedDate: string;
}

export interface CreateUserCommand {
  email: string;
  password: string;
  name: string;
  surname: string;
}

export interface PageResponseUserDto extends PageResponse<UserDto> { }

// ============================================
// AUTH MODELS
// ============================================

export interface LoginRequest {
  username: string;
  password: string;
}

export interface AuthResponseDto {
  token: string;
  userId: number;
  username: string;
  email: string;
  name: string;
  surname: string;
  expiresInSeconds: number;
  developerId?: number;
}

export interface TokenResponse {
  access_token: string;
  token_type: string;
  expires_in: number;
  scope?: string;
}

// ============================================
// UTILITY TYPES
// ============================================

export interface PaginationParams {
  page?: number;
  size?: number;
  sort?: string[];
}

export interface ApiError {
  status: number;
  message: string;
  details?: string;
  timestamp: string;
  path?: string;
}

// ============================================
// TYPE ALIASES FOR BACKWARD COMPATIBILITY
// ============================================

/** @deprecated Use InvestmentAddressDto instead */
export type InvestmentLocationDto = InvestmentAddressDto;

/** @deprecated Use ApartmentListItemView instead */
export type ApartmentListItemDto = ApartmentListItemView;

/** @deprecated Use ParkingDetailsDto instead */
export type ParkingCommand = ParkingRequest;

/** @deprecated Use AncillaryDetailsDto instead */
export type Ancillary = AncillaryDetailsDto;

/** @deprecated Use AncillaryVersionDto instead */
export type AncillaryVersion = AncillaryVersionDto;

/** @deprecated Use AncillaryRequest instead */
export type AncillaryCommand = AncillaryRequest;

/** @deprecated Use AncillaryVersionRequest instead */
export type AncillaryVersionCommand = AncillaryVersionRequest;

export interface GovEditPolicyDto {
  enabled: boolean;
  enabling: boolean;
  archived: boolean;
  saleStartDate?: string;
  minModifiableDate?: string;
}

/** @deprecated Use GovEditPolicyDto */
export type GovBaseDto = GovEditPolicyDto;

// ============================================
// GOV MODULE MODELS
// ============================================

export type GovExecutionStatus = 'SUCCESS' | 'FAILED';
export type GovValidationSeverity = 'ERROR' | 'WARNING';
export type GovEntityType = 'DEVELOPER' | 'HEADQUARTER' | 'INVESTMENT' | 'MAIN_SELLING_POINT' | 'INVESTMENT_LOCATION' | 'APARTMENT' | 'PARKING' | 'ANCILLARY' | 'ADDON';
export type GovValidationCode =
  | 'NO_VERSION_ON_DATE'
  | 'MISSING_HEADQUARTER'
  | 'INVALID_HEADQUARTER'
  | 'MISSING_MSP'
  | 'INVALID_MSP'
  | 'MISSING_XML_DATASET_FOR_INVESTMENT'
  | 'MISSING_INVESTMENT_LOCATION'
  | 'INVALID_INVESTMENT_LOCATION'
  | 'MISSING_SALE_START_DATE'
  | 'SALE_START_DATE_AFTER_SNAPSHOT_DATE'
  | 'INVESTMENT_ARCHIVED'
  | 'NO_VERSION_AT_SALE_START_DATE'
  | 'VERSION_BEFORE_SALE_START_DATE';

export interface GovPublicationDailyDto {
  day: string;
  status: string;
  statusReason?: string;
  taskRunId?: string;
  datasetsCount?: number;
  resourcesCount?: number;
  publishedAt?: string;
  xmlBlobPath?: string;
  md5BlobPath?: string;
}

export interface GovResourceDailyDto {
  investmentId: number;
  investmentTitle: string;
  snapshotDate: string;
  statusMain: string;
  severity: string;
  statusFilter: string;
  missingReasonCategory?: string;
  resourceVersionId?: number;
  resourceState?: string;
  resourceUrl?: string;
  taskRunId?: string;
  taskStatus?: string;
  taskStatusReason?: string;
  resourceCreatedDate?: string;
}

export interface GovResourceVersionDto {
  resourceVersionId: number;
  snapshotDate: string;
  state: string;
  createdBy: string;
  createdDate: string;
  activeFromDate: string;
  retiredAt?: string;
  replacedById?: number;
  resourceUrl?: string;
  blobPath?: string;
  blobVersionId?: string;
  contentLengthBytes?: number;
  taskRunId?: string;
}

export interface GovValidationLogDto {
  id: number;
  runId: string;
  developerId: number;
  investmentId: number;
  entityType: GovEntityType;
  entityId: number;
  snapshotDate: string;
  severity: GovValidationSeverity;
  code: GovValidationCode;
  message: string;
  createdAt: string;
}

export interface GovAdminRunDto {
  runKind: string;
  runId: string;
  parentRunId?: string;
  ownerJobRunId?: string;
  runType: string;
  status: string;
  developerId: number;
  investmentId?: number;
  snapshotDate?: string;
  latestAllowedResourceDate?: string;
  targetTo?: string;
  current: boolean;
  attemptNo: number;
  maxAttempts: number;
  triggeredBy: string;
  lockedBy?: string;
  startedAt: string;
  finishedAt?: string;
  durationMs?: number;
  statusReason?: string;
  errorCode?: string;
  errorMessage?: string;
  warningsCount?: number;
  errorsCount?: number;
  tasksTotal?: number;
  tasksSucceeded?: number;
  tasksFailed?: number;
  tasksSkipped?: number;
  totalRows?: number;
  apartmentRows?: number;
  parkingRows?: number;
  ancillaryRows?: number;
}

export interface GovAdminRunFlowNodeDto {
  id: string;
  label: string;
  type: string;
  status: string;
}

export interface GovAdminRunFlowEdgeDto {
  source: string;
  target: string;
  type: string;
}

export interface GovAdminRunFlowGraphDto {
  nodes: GovAdminRunFlowNodeDto[];
  edges: GovAdminRunFlowEdgeDto[];
}

export interface GovEnableResponse {
  errors: number;
  warnings: number;
  runId: string;
}

/** @deprecated Old model, use GovPublicationDailyDto or GovResourceDailyDto */
export interface GovExecutionDto {
  runId: string;
  investment?: InvestmentSelectOptionDto;
  snapshotDate: string;
  status: GovExecutionStatus;
  totalRows?: number;
  warningsCount?: number;
  errorsCount?: number;
  errorMessage?: string;
  startedAt: string;
}

/** @deprecated Use PageResponse<GovPublicationDailyDto> etc. */
export interface PageResponseGovExecutionDto extends PageResponse<GovExecutionDto> { }
export interface PageResponseGovFileDto extends PageResponse<GovFileDto> { }
export interface PageResponseGovPublicationDailyDto extends PageResponse<GovPublicationDailyDto> { }
export interface PageResponseGovResourceDailyDto extends PageResponse<GovResourceDailyDto> { }
export interface PageResponseGovAdminRunDto extends PageResponse<GovAdminRunDto> { }

/** @deprecated Use GovPublicationDailyDto or GovResourceDailyDto */
export interface GovFileDto {
  id: number;
  snapshotDate: string;
  investment: InvestmentSelectOptionDto;
  statistics: {
    totalRows: number;
    apartmentRows: number;
    parkingRows: number;
    ancillaryRows: number;
  };
  createdDate: string;
  createdBy: string;
  url: string;
}
